import { useTheme } from '@emotion/react';
import React, { useRef, useEffect, useState } from 'react';
import { StyledRealTimeText } from './style';

type RealTimeTextProps = {
  value: string | number;
};

const RealTimeText: React.FC<RealTimeTextProps> = ({ value }) => {
  const theme = useTheme();

  const [backgroundColor, setBackgroundColor] = useState('transparent');
  const updateTimer = useRef(undefined);

  const setUpdate = (): void => {
    setBackgroundColor(theme.colors.sun30);

    updateTimer.current = setTimeout(() => {
      setBackgroundColor('transparent');
      updateTimer.current = null;
    }, 1000);
  };

  useEffect(() => {
    if (updateTimer.current === undefined) updateTimer.current = null;
    else if (!updateTimer.current) setUpdate();
  }, [value]);

  useEffect(
    () => (): void => updateTimer.current && clearTimeout(updateTimer.current),
    [],
  );

  return (
    <StyledRealTimeText fontFamily="inherit" bg={backgroundColor}>
      {value}
    </StyledRealTimeText>
  );
};

export default RealTimeText;
